export default __webpack_public_path__ + "static/media/warning.9b3ec911.svg";